import axios from "axios";
import baseUrl from "../config";

const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

const create = async (user) => {
  try {
    const response = await axiosInstance.post(
      "/pizza-api/users/register",
      user
    );
    return response.data;
  } catch (err) {
    console.log(err);
    return { error: err };
  }
};

const list = async () => {
  try {
    const response = await axiosInstance.get("/pizza-api/users");
    return response.data;
  } catch (err) {
    console.log(err);
    return { error: err };
  }
};

const read = async (params, token) => {
  try {
    const response = await axiosInstance.get(
      `/pizza-api/users/${params.userId}`,
      {
        headers: {
          Authorization: "Bearer " + token.t,
        },
      }
    );
    return response.data;
  } catch (err) {
    console.log(err);
    return { error: err };
  }
};

const update = async (userId, user) => {
  try {
    const response = await axiosInstance.put(
      `/pizza-api/users/${userId}`,
      user
      // , {
      //   headers: {
      //     Authorization: "Bearer " + token.t,
      //   },
      // }
    );
    return response.data;
  } catch (err) {
    console.log(err);
    return { error: err };
  }
};

const remove = async (params, token) => {
  try {
    const response = await axiosInstance.delete(
      `/pizza-api/users/${params.userId}`,
      {
        headers: {
          Authorization: "Bearer " + token.t,
        },
      }
    );
    return response.data;
  } catch (err) {
    console.log(err);
    return { error: err };
  }
};

export { create, list, read, update, remove };
